import classNames from "./Landing.module.css";
import Header from "../../Header";
import Button from "../../common/Button";
import { useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TryTranslation from "./TryTranslation";
import meetingAndPhoneImg from "../../../assets/stock/meeting_and_phone.webp";
import eventPhoneImg from "../../../assets/stock/event_phone.webp";
import eventStageImg from "../../../assets/stock/event_stage.webp";
import interpreterPhonesImg from "../../../assets/stock/interpreter_phones.webp";
import integrationImg from "../../../assets/stock/integration.webp";
import teamsImg from "../../../assets/platforms/teams.svg";
import meetImg from "../../../assets/platforms/meet.svg";
import zoomImg from "../../../assets/platforms/zoom.svg";
import Testimonies from "./Testimonies";
import { VoiceList } from "../../common/dialogs/voice/VoiceAvatar";
import TryDomainTranslation from "./TryDomainTranslation";
import Morse from "./Morse";
import { TypeAnimation } from "react-type-animation";
import ByrdhouseBanner from "../../common/ByrdhouseBanner";
import { useRedirectAfterLogin } from "../../../hooks/redirect-after-login";
// import CompaniesSlider from "./CompaniesSlider";
import netvalImg from "../../../assets/testimonies/landing/netval.webp";
import forgeworksImg from "../../../assets/testimonies/landing/forgeworks.webp";
import filuetImg from "../../../assets/testimonies/landing/filuet.webp";
import meetsmoreImg from "../../../assets/testimonies/landing/meetsmore.webp";
import nacCanadaImg from "../../../assets/testimonies/landing/nac_canada.webp";
import nacCanadaImg2 from "../../../assets/testimonies/landing/nac_canada_2.webp";
import icustomerImg from "../../../assets/testimonies/landing/icustomer.webp";
import ambrosettiImg from "../../../assets/testimonies/landing/ambrosetti.webp";

import timImg from "../../../assets/testimonies/tim.webp";
import yuvalImg from "../../../assets/testimonies/yuval.webp";
import vitzImg from "../../../assets/testimonies/vitz.webp";
import maurizioImg from "../../../assets/testimonies/maurizio.webp";
import federicoImg from "../../../assets/testimonies/federico.webp";
import mikeImg from "../../../assets/testimonies/mike.webp";
import mattImg from "../../../assets/testimonies/matt.webp";
import Footer from "./Footer";
import { useLogEvent } from "../../../hooks/log";

const accuracyTestimonies = [
  {
    companyImage: netvalImg,
    quote:
      "We really enjoyed the experience. The translation is 95% precise between Italian and English. The quality is impressive - fast and accurate.",
    name: "Federico",
    title: "PMO of Netval",
    image: federicoImg,
  },
  {
    companyImage: forgeworksImg,
    quote:
      "It surprised me when it translated Macedonian into a high dialect or polite form, recognizing the professional context. That level of adaptability is what makes Langfinity stand out.",
    name: "Vitz",
    title: "Co-Founder, Partner & Managing Director at ForgeWorks",
    image: vitzImg,
  },
  {
    companyImage: filuetImg,
    quote:
      "For our country managers, the real-time translations were not only accurate but also preserved the nuance and meaning of the conversations.",
    name: "Yuval",

    title: "AI Integration Manager at Filuet",
    image: yuvalImg,
  },
  {
    companyImage: meetsmoreImg,
    quote:
      "Every meeting has at least a few technical terms that aren't standard. With Langfinity, we can now update those terms easily, which has made a big difference.",
    name: "Zach",
    // TODO:
    title: "MeetsMore",
    image: meetsmoreImg,
  },
];

const effeciencyTestimonies = [
  {
    companyImage: nacCanadaImg2,
    quote:
      "Setting it up was a breeze. We went from no translation to real-time translation in four languages in just 5 minutes. The user experience was so intuitive—attendees just scanned a QR code, and they were instantly connected to the translation they needed.",
    name: "Matt",
    title: "Language Coordinator at the New Apostolic Church Canada",
    image: mattImg,
  },

  {
    companyImage: ambrosettiImg,
    quote:
      "Before Langfinity, our search for interpreters was a time-consuming, expensive affair. Now, not only do we save on time and costs, but we also provide an inclusive experience for diverse voices to interact seamlessly.",
    name: "Maurizio",
    title: "Customer Obsession Circle Leader at The European House-Ambrosetti",
    image: maurizioImg,
  },
  {
    companyImage: nacCanadaImg,
    quote:
      "This solution was a lifesaver. It saved us countless hours and effort that would have gone into  setting up traditional interpretation systems. The fact that we could rely on Langfinity for both human and AI-powered translation in real time was a huge win for us.",
    name: "Mike",
    title: "Project Manager at the New Apostolic Church Canada",
    image: mikeImg,
  },
  {
    companyImage: icustomerImg,
    quote:
      "The fact that we went and bothered to get a translator that was easy to use showed real respect for how we do business. It broke down a barrier between countries and allowed us to connect with confidence.",
    name: "Tim",
    title: "Managing Director at iCustomer",
    image: timImg,
  },
];

function Landing() {
  const logEvent = useLogEvent();

  const clickGetADemo = useCallback(() => {
    logEvent({ type: "click_get_a_demo_landing" });
    window.open(
      "https://calendly.com/d/cs8h-bpy-tzc/langfinity-intro",
      "_blank"
    );
  }, [logEvent]);

  const navigate = useNavigate();

  const { pathname } = useLocation();
  const [, setRedirectAfterLogin] = useRedirectAfterLogin();
  useEffect(() => {
    setRedirectAfterLogin({ pathname: pathname });
  }, [pathname, setRedirectAfterLogin]);

  return (
    <>
      <div className={classNames.Landing}>
        <ByrdhouseBanner />
        <Header landing={true} />

        <div className={classNames.LandingContent}>
          <section className={classNames.Hero}>
            <Morse />
            <h1>
              <div>Real-time translation for</div>

              <TypeAnimation
                sequence={[
                  "multilingual meetings",
                  2000,
                  "global all hands",
                  2000,
                  "trainings",
                  2000,
                  "worship services",
                  2000,
                  "events and conferences",
                  2000,
                  "customer calls",
                  2000,
                ]}
                wrapper="div"
                speed={50}
                repeat={Infinity}
              />
            </h1>
            <h3>
              Powered by company-specific models built to understand your
              terminology and context
            </h3>

            <div className={classNames.Buttons}>
              <Button
                size="landing"
                color="white"
                backgroundColor="orange"
                borderColor="orange"
                onClick={clickGetADemo}
              >
                Get a demo
              </Button>
              <Button
                size="landing"
                color="black"
                backgroundColor="transparent"
                borderColor="black"
                onClick={() => navigate("/signup")}
              >
                Try for free
              </Button>
            </div>

            <>
              <h2>See and hear Langfinity in action</h2>
              <TryTranslation />
            </>
            {/* <h3 className={classNames.CompaniesSubtitle}>
              Loved by leading organizations to translate millions of hours per
              year
            </h3>
            <CompaniesSlider /> */}
          </section>

          <section className={classNames.MeetingSection}>
            <h2 className={classNames.MaxWidthSectionHeader}>
              Connect with your global team in any language with just one click
            </h2>
            <div>
              <div>
                <div>
                  <h3>Effortless multi-way translation</h3>
                  <p>
                    Simply select your language, and our AI ensures you see and
                    hear translations in real time—no matter what languages
                    others speak.
                  </p>
                </div>
                <div>
                  <h3>Natural voice-to-voice translation</h3>
                  <p>
                    Speak freely with voice avatars that capture your
                    personality and tone. Langfinity's voice translation
                    delivers lifelike, expressive communication.
                  </p>
                </div>
                <div>
                  <h3>Multilingual meeting notes & recordings</h3>
                  <p>
                    Get video recordings and transcripts in your preferred
                    language, complete with key highlights and summaries—so you
                    can focus on the conversation, not taking notes.
                  </p>
                </div>
              </div>
              <img src={meetingAndPhoneImg} alt="Meeting and phone" />
            </div>
            <Button
              size="landing"
              backgroundColor="transparent"
              borderColor="white"
              color="white"
              onClick={clickGetADemo}
            >
              See it in action
            </Button>
          </section>

          <section className={classNames.DomainFocusedSection}>
            <h2 className={classNames.MaxWidthSectionHeader}>
              Domain-focused translation delivers highly relevant and precise
              communication for your industry
            </h2>
            <TryDomainTranslation />
          </section>

          <section className={classNames.IntegrationSection}>
            <div>
              <h2>
                Get real-time translation in Teams, Zoom, and Google Meet with a
                single tap
              </h2>
              <h3>
                See and hear real-time translation directly in your meeting
                platform. Langfinity's AI translation adapts to your industry's
                terminology for precise and productive multilingual
                communication.
              </h3>
              <Button
                size="landing"
                backgroundColor="transparent"
                borderColor="white"
                color="white"
                onClick={clickGetADemo}
              >
                See it in action
              </Button>
            </div>
            <div>
              <img src={integrationImg} alt="Meeting platform integrations" />
              <h3>Supported platforms</h3>
              <div className={classNames.Platforms}>
                <div>
                  <img src={teamsImg} alt="Microsoft Teams" />
                </div>
                <div>
                  <img src={zoomImg} alt="Zoom" />
                  <div className={classNames.ComingSoon}>Coming soon</div>
                </div>
                <div>
                  <img src={meetImg} alt="Google Meet" />
                  <div className={classNames.ComingSoon}>Coming soon</div>
                </div>
              </div>
            </div>
          </section>

          <section className={classNames.TestimoniesSection}>
            <div>
              <h2>
                Fast and accurate translation trusted by top organizations
              </h2>
              <div className={classNames.Metrics}>
                <div>
                  <h3>Accuracy</h3>
                  <p>
                    {
                      "Baseline models for popular languages achieve >85% translation accuracy, with even greater precision through industry-specific fine-tuning."
                    }
                  </p>
                </div>
                <div>
                  <h3>Speed</h3>
                  <p>
                    {
                      "Experience lightning-fast translation—under 300ms for voice-to-text and 1-3 seconds for voice-to-voice."
                    }
                  </p>
                </div>
              </div>
            </div>
            <Testimonies testimonies={accuracyTestimonies} theme="light" />
          </section>

          <section className={classNames.VoiceAvatarSection}>
            <h2>Speak globally, stay you</h2>
            <h3>
              Translate in your own tone and personality with AI voice avatars
              that truly represent you
            </h3>
            <div>
              <div>
                <h3>🇺🇸 English</h3>
                <VoiceList language="en-US" />
              </div>
              <div>
                <h3>🇲🇽 Español</h3>
                <VoiceList language="es-MX" />
              </div>
              <div>
                <h3>🇨🇳 中文</h3>
                <VoiceList language="zh-CN" />
              </div>
            </div>
          </section>

          <section className={classNames.EventSection}>
            <h2 className={classNames.MaxWidthSectionHeader}>
              Scan a QR code to unlock real-time translation in 50+ languages
              for your events
            </h2>

            <div className={classNames.ThreeColumn}>
              <div>
                <h3>Translation on any device, anywhere</h3>
                <p>
                  Langfinity works anywhere—remote, hybrid, or in-person. With a
                  quick QR scan, attendees get instant translation for meetings,
                  worship services, global all-hands, training, and more.
                </p>
              </div>
              <div>
                <h3>Multi-speaker, multi-language translation</h3>
                <p>
                  Langfinity supports multiple speakers in different languages
                  and even detects the language you speak. Speakers choose their
                  language, and audiences hear and see translations in real
                  time.
                </p>
              </div>
              <div>
                <h3>Authentic voice avatars that sound like you</h3>
                <p>
                  Go beyond text translation with lifelike, expressive AI voice
                  translation that match your personality and tone. Choose the
                  best voice representation to ensure a natural and engaging
                  experience for your audience.
                </p>
              </div>
            </div>

            <div className={classNames.ThreeImages}>
              <div>
                <img
                  src={eventPhoneImg}
                  alt="Event attendee listening with phone translation"
                />
              </div>
              <div>
                <img
                  src={eventStageImg}
                  alt="Event translation displayed on stage"
                />
              </div>
              <div>
                <img
                  src={interpreterPhonesImg}
                  alt="Phones used by interpreters to provide live translation"
                />
              </div>
            </div>
          </section>

          <section className={classNames.TestimoniesSection2}>
            <div>
              <h2>
                <span>15X</span> translation cost savings
              </h2>
              <h2>
                <span>2X</span> faster meeting time{" "}
              </h2>
              <h2>
                Create <span>meaningful</span>, <span>universal</span> human
                connection
              </h2>
            </div>

            <Testimonies testimonies={effeciencyTestimonies} theme="dark" />
          </section>

          <section className={classNames.Hero}>
            <Morse />
            <h2>Ready to get sarted?</h2>
            <h3>
              Meet, speak, and connect seamlessly through AI-powered,
              industry-specific voice translation in 50+ languages
            </h3>

            <div className={classNames.Buttons}>
              <Button
                size="landing"
                color="white"
                backgroundColor="orange"
                borderColor="orange"
                onClick={clickGetADemo}
              >
                Get a demo
              </Button>
              <Button
                size="landing"
                color="black"
                backgroundColor="transparent"
                borderColor="black"
                onClick={() => navigate("/signup")}
              >
                Try for free
              </Button>
            </div>
          </section>

          <Footer />
        </div>
      </div>
    </>
  );
}

export default Landing;
